import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Text } from '@cotera/client/app/components/ui';
import { Button } from '@cotera/client/v0/components/ui/button';
import { ScrollArea } from '@cotera/client/v0/components/ui/scroll-area';

/**
 * Shown when the list's fetch failed. Without this a failed load is
 * indistinguishable from a slow one — the list would sit on its skeleton
 * forever, since a rejected fetch leaves the backing watchable at its initial
 * `null` value.
 */
export function ResourceListErrorState({
  errorText,
  onRetry,
  compact = false,
}: {
  errorText: string;
  onRetry?: () => void;
  /** Smaller padding for drawer / bottom-panel hosts. */
  compact?: boolean;
}): React.ReactElement {
  return (
    <ScrollArea className="flex-1 min-h-0 -mr-4 pr-4">
      <div
        role="alert"
        className={
          compact
            ? 'flex flex-col items-center justify-center py-8 text-center'
            : 'flex flex-col items-center justify-center py-20 text-center'
        }
      >
        {compact ? null : (
          <AlertCircle
            className="h-12 w-12 text-muted-foreground/50 mb-4"
            aria-hidden="true"
          />
        )}
        <Text.P className="text-muted-foreground mt-1">{errorText}</Text.P>
        {onRetry !== undefined && (
          <Button onClick={onRetry} variant="outline" className="mt-5">
            Try again
          </Button>
        )}
      </div>
      {compact ? null : <div className="pb-8" />}
    </ScrollArea>
  );
}
